import React, {useState, useEffect} from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import SupplierPage from "./steps/SupplierPage";
import useWizard from "../../hooks/useWizard";
import useRunOnce from "../../hooks/useRunOnce";
import {useParams} from "react-router-dom";
import {getPublicSupplierDataAction} from "../../store/actionCreators";
import {connect} from "react-redux";
import SeoCompSupplier from "../SeoCompSupplier";
import {useTranslation} from "react-i18next";
import { getSubdomain } from '../../utils/getSubdomain';
import SelectDate from './steps/SelectDate';
import CreateAppointmentDialog from "../schedule/CreateAppointmentDialog";
import {useDialog} from "../Dialog";
import {dateAndTimeInputFormat} from '../../utils'
import Thankyou from './steps/Thankyou';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        overflow: 'hidden',
        height:'100%'
    }

}));

const BookingWizard = ({getPublicSupplierData, supplierPersonalDetails, activitiesStrings, isErrorInGetSupplier}) => {
    const classes = useStyles()
    const {activeStep, handleBack, handleNext} = useWizard({});
    const {DialogComp, handleClickOpen} = useDialog(CreateAppointmentDialog)
const [bookingData, setBookingData] = useState(null)
    const {shortHash = getSubdomain()} = useParams()
    useRunOnce(() => {
        if (shortHash) {
            getPublicSupplierData(shortHash)
        }

    })
    const {fullName, images, description, professionId, address,_id:supplierId} = supplierPersonalDetails || {}
    const addressTitle = typeof address === 'string' ? address : address?.title;

    const {t} = useTranslation();
    if(isErrorInGetSupplier){
       window.location.href = 'https://agendia.mx'
    }

    useEffect(()=>{
        if(professionId){
            window.prerenderReady = true;
        } else {
            window.prerenderReady = false;
        }
    },[professionId])


    return <div className={classes.root}>
        <SeoCompSupplier title={`${fullName} - ${professionId?.heName}`} image={images && images[0]?.url}
                 description={`${activitiesStrings} ${description ? description : ''}, ${addressTitle ? `${t('in-address')}: ${addressTitle}` : ''}`}/>
        {activeStep === 0 && <SupplierPage handleNext={handleNext} supplierPersonalDetails={supplierPersonalDetails}/>}
        {activeStep === 1 && <SelectDate onSelect={({selectedTime, services, customerAddress})=>{
            setBookingData({services,selectedTime,handleClickOpen,customerAddress})
            const servicesHash = services.reduce((combinedHash,service)=>{
                const {_id} = service;
                combinedHash+=`${_id}#`
                return combinedHash
            },'')
            handleClickOpen({
                dateStr: dateAndTimeInputFormat(new Date(selectedTime)),
                 supplierId,
                 servicesHash,
                  isAdmin:false,
                  customerAddress,
                   onFinish:()=>{
                    handleNext();
                   }})
        }} shortHash={shortHash} handleBack={handleBack} />}
                {activeStep === 2 && <Thankyou bookingData={bookingData} location={supplierPersonalDetails.address} />}
        {DialogComp}
    </div>
}

const mapStateToProps = (state) => ({
    supplierPersonalDetails: state.general.supplier?.personalData,
    activitiesStrings: state.general.supplier?.activities?.length > 1 ? state.general.supplier?.activities.map(({subProfessionId: {heName}}) => heName).join(', '):'',
    isErrorInGetSupplier: !!state.general?.error
})
const mapDispatchToProps = dispatch => ({
    getPublicSupplierData: getPublicSupplierDataAction(dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(BookingWizard);